<script lang="ts">
  import SettingModal from './SettingModal.svelte';
</script>

<SettingModal title="후원 설정" icon="fas fa-donate">
  <div slot="body">여기가 바디</div>
</SettingModal>
